<!-- Main -->
<div id="main" class="wrapper style1">
  <div class="container">
    <header class="major" id="dorothee18">
      <h2>About Us</h2>
      <p>Mic Lord</p>
    </header>

    <!-- Content -->
    <section id="content">
      <a href="#" class="image fit"
        ><img src="./assets/images/Mic-Lord-Redemption.jpg" alt=""
      /></a>
      <h3>Play your Part</h3>

      <p>
        Mic is a London born, Texas raised Theatre Maker, MC, recording artist,
        Teacher, Lecturer and Community Advocate. 
      </p>
      <p>
        Since 1993 his Hip hop Freestyle Performance Company Ghetto Gramma has
        toured extensively across the nation devising theatre in marginalised
        communities. Performing at Albany Deptford, Battersea Arts Centre.
        Contact Theatre, Manchester, Derby Playhouse, Nottingham Playhouse, Oval
        House the companies devised performances invigorate community activism.
        He’s directed over 100 plays and musicals with his most recent theatre
        work including Jaberwocky at New Wimbledon Studio and Evita at Epsom
        Playhouse. 
      </p>
      <p>
        Mic is the former Head of Drama at Ursuline High School,Wimbledon. In
        2007 he was the recipient of South London Press Hero Teacher Award. 
      </p>
      <p>
        Since 2018 he has been the Head Coach at Five ASide Theatre CIC a
        community theatre training company. He’s also the founder and Artistic
        Director of The Peoples Writes a community theatre devising
        company. They’re currently devising Dorothee 18 a multi-artfom
        performance exploring African Caribbeans in Sutton in the 18th century.
      </p>
      <p>
        Mic takes an active role within the local community as a Governor at
        Ursuline High School working on the Sub Committee on Equality, Diversity
        and Inclusion. He’s a Trustee at Apples and Snakes Poetry. Since 2021
        he’s the current Chair of the Community Committee and serves on the
        Advisory Council at Polka Theatre. 
      </p>
      <h2>Five ASide Theatre</h2>
      <p>
        With <strong>FASThemes</strong> we partner with Charities, Arts
        Organisations and Schools to create performances around issues of
        imminent importance. Presently we’re partnering with Sutton African
        Caribbean Cultural Organisation with Dorothee in the 18th century. This
        is a locally researched and written production exploring the earliest
        African Caribbeans in south London at Charles Cryer Theatre October 23rd
      </p>
      <p>
        In <strong>FASTraining</strong> we train emerging artists as community
        performers and workshop practitioners.
      </p>
      <p>
        <strong>FASTournaments</strong> are our half term Academies for 9-16
        year old using multi-sports and Theatre Games to promote a healthy
        lifestyle.
      </p>

      <a href="#" class="image fit"
        ><img src="./assets/images/miclordBG.jpg" alt=""
      /></a>
    </section>
  </div>
</div>
